import React from "react";
// import Datepicker from "flowbite-datepicker/Datepicker";
import RateTariffComponent from "../common/RateTariffComponent";

const RateCalculator = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px] mb-[5rem]">
        <h1 className="lg:text-[40px] text-[30px] font-bold">
          Rate Calculator
        </h1>
      </div>

      <RateTariffComponent />

      {/* <div className="flex flex-col justify-center items-center bg-[#FAFBFC] mt-[5rem] mb-[rem]">
        <h1 className="font-bold lg:text-4xl text-3xl mb-[3rem] mt-[3rem]">
          Frequently Asked Questions
        </h1>
      </div>

      <div className="flex flex-col justify-center bg-[#FAFBFC] text-center pb-[4rem]">
        <div
          id="accordion-collapse"
          className="lg:w-[50rem] w-[20rem] mx-auto "
          data-accordion="collapse"
        >
          <details className="bg-transparent">
            <summary className="bg-[#FAFBFC]">
              <span className="summary-title">
                {" "}
                What are the range of services and solutions provided by TCS?
              </span>
              <div
                className="summary-chevron-down"
                style={{ backgroundColor: "#FAFBFC" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-chevron-down"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </summary>

            <div className="summary-content">
              To view our range of services, click the Services and Solutions
              tab on top of the TCS homepage
            </div>

            <div
              className="summary-chevron-down"
              style={{ backgroundColor: "#FAFBFC" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-chevron-up"
              >
                <polyline points="18 15 12 9 6 15"></polyline>
              </svg>
            </div>
          </details>

          <details className="bg-transparent">
            <summary className="bg-[#FAFBFC]">
              <span className="summary-title">
                {" "}
                What are the range of services and solutions provided by TCS?
              </span>
              <div
                className="summary-chevron-down"
                style={{ backgroundColor: "#FAFBFC" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-chevron-down"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </summary>

            <div className="summary-content">
              To view our range of services, click the Services and Solutions
              tab on top of the TCS homepage
            </div>

            <div
              className="summary-chevron-down"
              style={{ backgroundColor: "#FAFBFC" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-chevron-up"
              >
                <polyline points="18 15 12 9 6 15"></polyline>
              </svg>
            </div>
          </details>

          <details className="bg-transparent">
            <summary className="bg-[#FAFBFC]">
              <span className="summary-title">
                {" "}
                What are the range of services and solutions provided by TCS?
              </span>
              <div
                className="summary-chevron-down"
                style={{ backgroundColor: "#FAFBFC" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-chevron-down"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </summary>

            <div className="summary-content">
              To view our range of services, click the Services and Solutions
              tab on top of the TCS homepage
            </div>

            <div
              className="summary-chevron-down"
              style={{ backgroundColor: "#FAFBFC" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-chevron-up"
              >
                <polyline points="18 15 12 9 6 15"></polyline>
              </svg>
            </div>
          </details>
        </div>

        <div className="flex justify-center">
          <button className="flex justify-center text-sm bg-[#D40511] hover:bg-[#F21E26] text-white p-2 w-full md:w-[10rem] rounded-r-sm transition-all duration-500 mt-8">
            More FAQs
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default RateCalculator;
